import { Link } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import React from "react";
import { useMsal } from "@azure/msal-react";

interface AccountCircleProps {
  name: string;
}

const AccountCircle: React.FC<AccountCircleProps> = ({ name }) => {
  return (
    <Box
      sx={{
        alignItems: "center",
        backgroundColor: "#002B6B",
        borderRadius: "50%",
        color: "#6680A6",
        display: "flex",
        fontFamily: "Lato",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 600,
        height: "32px",
        justifyContent: "center",
        lineHeight: "normal",
        width: "32px",
      }}
    >
      {name}
    </Box>
  );
};

const Topbar = () => {
  const { instance } = useMsal();

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: "transparent", boxShadow: "none" }}
    >
      <Toolbar
        disableGutters
        sx={{ justifyContent: "space-between", marginTop: "20px" }}
      >
        <IconButton
          component={Link}
          to="/"
          edge="start"
          sx={{ padding: 0, marginLeft: "40px" }}
        >
          <img src="/norlys.png" alt="Norlys" style={{ height: "32px" }} />
        </IconButton>
        <IconButton
          edge="end"
          sx={{ padding: 0, marginRight: "40px" }}
          onClick={async () =>
            await instance.logoutRedirect().then().catch(console.error)
          }
        >
          <AccountCircle name="NC" />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
